export const loadOneTrust = (domainId) => {
  return new Promise((resolve, reject) => {
    if (window.Optanon) {
      resolve();
      return;
    }

    const existingScript = document.querySelector(`script[data-domain-script="${domainId}"]`);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.setAttribute('data-domain-script', domainId);
    script.setAttribute('data-document-language', 'true');

    script.onload = () => {
      resolve();
    }

    script.onerror = (e) => {
      reject(e);
    }

    document.head.appendChild(script);
  });
}
